import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from 'eshava-shared';

import { Icon } from '@portal/shared/ui/icon/icon';

/**
 * The one page that renders without a token, besides the OIDC callback.
 *
 * Deliberately bare: no navigation, no context selection, no data. It says the address does not
 * exist and offers a way back — anything more would tell someone who is not signed in what the
 * application contains.
 */
@Component({
  selector: 'portal-not-found-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, Icon, TranslatePipe],
  template: `
    <div class="not-found">
      <portal-icon name="circle-exclamation-solid" size="lg" />
      <h1>{{ 'error.notFound.title' | t }}</h1>
      <p>{{ 'error.notFound.text' | t }}</p>
      <a routerLink="/">{{ 'error.notFound.back' | t }}</a>
    </div>
  `,
  styles: `
    :host {
      display: grid;
      place-items: center;
      min-height: 100vh;
      padding: var(--space-5);
    }

    .not-found {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--space-3);
      color: var(--text-muted);
      text-align: center;
    }
  `
})
export class NotFoundPage {}